import type { FC } from 'react'

export const Address: FC<{
  street1?: string | null
  street2?: string | null
  zip?: string | null
  city?: string | null
  country?: string
}> = ({ street1, street2, zip, city, country }) => {
  const zipAndCity = zip && city ? `${zip}, ${city}` : `${zip || ''}${city ? ` ${city}` : ''}`
  return (
    <address className="font-normal">
      {street1 && <>{street1}</>}

      {street2 && (
        <>
          {street1 && <br />}
          {street2}
        </>
      )}

      {(zip || city) && (
        <>
          {(street1 || street2) && <br />}
          {zipAndCity}
        </>
      )}

      {country && (
        <>
          {(street1 || street2 || zip || city) && <br />}
          {country}
        </>
      )}
    </address>
  )
}
